// extracted by mini-css-extract-plugin
export default {"resizable_popup":"DebugCC_resizable_popup__KAF18","scrollable_content":"DebugCC_scrollable_content__afgDD"};